import { CheckOutlined, WarningOutlined } from '@ant-design/icons';
import { Modal, ModalProps, Typography } from 'antd';

interface ConfirmRequestJobPostingApprovalModalProps extends ModalProps {
  requestJobPostingName: string;
}

const ConfirmRequestJobPostingApprovalModal = ({
  requestJobPostingName,
  ...props
}: ConfirmRequestJobPostingApprovalModalProps) => {
  return (
    <Modal
      title={
        <Typography.Text strong>
          <WarningOutlined /> Atenção! Esta requisição será concluída!
        </Typography.Text>
      }
      okButtonProps={{
        icon: <CheckOutlined />,
      }}
      okText="Aprovar"
      cancelText="Cancelar"
      {...props}
    >
      <Typography.Paragraph>
        Ao aprovar a requisição <Typography.Text strong>{requestJobPostingName}</Typography.Text>,
        ela será concluída e a vaga correspondente será criada automaticamente na aba de{' '}
        <Typography.Text strong>Vagas</Typography.Text>. Não haverá possibilidade de reiniciar a
        requisição após a conclusão.
      </Typography.Paragraph>
    </Modal>
  );
};

export default ConfirmRequestJobPostingApprovalModal;
